/**
 * academia/rutas.js — qué lecciones ve cada persona: el tronco común (todos) + la ruta de su rol.
 * CEO, MD y COO ven todas las rutas. Un rol que no está acá ve solo el tronco.
 * Los ids de abajo que todavía no tienen archivo en lecciones/ simplemente no se muestran.
 */
import { LECCIONES, getLecciones } from "./index.js";

export const TRONCO = ["01", "02", "03", "04"];

export const RUTAS = {
  ec:        { etiqueta: "Ejecutivas de cuenta", roles: ["EC"],                                                      lecciones: ["E1", "E2"] },
  com:       { etiqueta: "Community",            roles: ["COM", "CM", "SMM"],                                         lecciones: ["M1"] },
  ccc:       { etiqueta: "Coordinación",         roles: ["CCC", "CPC", "COO"],                                        lecciones: ["C1", "C2", "C3"] },
  creativos: { etiqueta: "Creativos",            roles: ["Diseñador", "Audiovisual", "Editor", "Videógrafo", "Fotógrafo"], lecciones: ["K2", "K3"] },
  cfo:       { etiqueta: "Finanzas",             roles: ["CFO", "Admin"],                                             lecciones: ["F1"] },
};

const DIRECCION = ["ceo", "md", "coo"];
const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();

/** Roles de una persona: el principal + los extra (roles_extra puede venir como array o como JSON en texto). */
export function rolesDe(rol, rolesExtra) {
  let extras = rolesExtra;
  if (typeof extras === "string") { try { extras = JSON.parse(extras); } catch { extras = []; } }
  return [rol, ...(Array.isArray(extras) ? extras : [])].map(x => String(x || "").trim()).filter(Boolean);
}

/** Ids de lección que corresponden a una persona, en orden: tronco + ruta(s) de todos sus roles. Acepta un rol o una lista. */
export function idsParaRol(rol) {
  const roles = (Array.isArray(rol) ? rol : [rol]).map(norm);
  const verTodo = roles.some(r => DIRECCION.includes(r));
  const ids = [...TRONCO];
  for (const ruta of Object.values(RUTAS)) {
    if (verTodo || ruta.roles.some(x => roles.includes(norm(x)))) ids.push(...ruta.lecciones);
  }
  return [...new Set(ids)];
}

/** Lecciones (con archivo) que ve una persona según su rol (o lista de roles). */
export function leccionesParaRol(rol) {
  return getLecciones(idsParaRol(rol));
}

/** Etiqueta de la ruta de una lección para mostrar en la lista («Tronco común», «Coordinación»…). */
export function etiquetaDeGrupo(grupo) {
  if (grupo === "tronco") return "Tronco común";
  return RUTAS[grupo]?.etiqueta || grupo;
}

export { LECCIONES };
